module.exports = __webpack_public_path__ + "img/app.9d4a28c6.png";